import React from 'react'
import { useFormContext } from 'react-hook-form'
import { TextAreaQuestion as TextAreaQuestionType } from '../../../../types/end-journey'
import { countWords } from '../../../../utils/text'
import { BaseQuestionLayout } from '../BaseQuestionLayout'

interface TextAreaQuestionProps {
  name: string
  question: TextAreaQuestionType
  rules?: {
    required?: string | false
    minWords?: {
      value: number
      message: string
    }
  }
}

export const TextAreaQuestion: React.FC<TextAreaQuestionProps> = ({
  name,
  question,
  // rules,
}) => {
  const {
    register,
    watch,
    formState: { errors },
  } = useFormContext()
  const formName = `${name}_other`
  const value = watch(formName) || ''
  const error = errors[formName]?.message as string | undefined

  const wordCount = countWords(value)
  const showWordCount = question.minWordLimit !== undefined

  const validateWordCount = (value: string) => {
    console.log('text area, validateWordCount', value)
    if (!question.minWordLimit) return true
    const words = countWords(value)
    return (
      words >= question.minWordLimit ||
      `Please write at least ${question.minWordLimit} words`
    )
  }

  const rules = {
    required: !question.optional && 'This field is required',
    minWords: question.minWordLimit
      ? {
          value: question.minWordLimit,
          message: `Minimum ${question.minWordLimit} words required`,
        }
      : undefined,
    validate: validateWordCount,
  }

  return (
    <BaseQuestionLayout question={question} error={error}>
      <div className="space-y-2">
        <textarea
          {...register(formName, rules)}
          placeholder={question.placeholder}
          rows={6}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 resize-none"
        />
        <div className="flex justify-end gap-4">
          {showWordCount && (
            <span className="text-sm text-gray-500">
              {wordCount} {wordCount === 1 ? 'word' : 'words'}
              {!question.optional &&
              question.minWordLimit &&
              wordCount < question.minWordLimit ? (
                <span className="text-red-500 ml-2">
                  (Minimum {question.minWordLimit} words required)
                </span>
              ) : null}
            </span>
          )}
        </div>
      </div>
    </BaseQuestionLayout>
  )
}
